import React from "react";
import { DirectionRight } from "@/Icons";
import { EmptyState } from "@ad/anq-ui";
import { QueryHomeInfoResult } from "@/api/home/interface";
import moment from "moment";

interface Props {
  homeInfo: QueryHomeInfoResult;
}

const News = ({ homeInfo }: Props) => {
  const handleJump = () => {
    window.open("https://shuyuan.pinduoduo.com/courseSeries/33");
  };

  return (
    <div className="h-full rounded-lg bg-white p-6">
      <div className="title mb-6 overflow-hidden">
        <span className="text-base font-semibold leading-8">最新动态</span>
        <div className="title-tools float-right flex">
          <span
            className="dmp-link ml-4 flex h-8 cursor-pointer items-center text-text-black/[.65]"
            onClick={handleJump}
          >
            查看全部
            <DirectionRight />
          </span>
        </div>
      </div>

      <div>
        {homeInfo?.courseList?.length ? (
          <ul className="flex flex-col gap-2">
            {homeInfo.courseList.map((item) => (
              <li key={item.courseId} className="flex overflow-hidden text-sm">
                <span
                  className="dmp-link mr-2 flex-1 cursor-pointer overflow-hidden text-ellipsis whitespace-nowrap"
                  onClick={() =>
                    window.open(
                      `https://shuyuan.pinduoduo.com/courseDetail/${item.courseId}`
                    )
                  }
                >
                  {item.courseName}
                </span>
                <span className="text-text-black/[.65]">
                  {moment(item.updateTime).format("MM/DD")}
                </span>
              </li>
            ))}
          </ul>
        ) : (
          <div>
            <EmptyState />
          </div>
        )}
      </div>
    </div>
  );
};

export default News;
